// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const isObject = (object: any): boolean => {
  return object !== null && typeof object === 'object'
}

export const isDeepEqual = (object1 = {}, object2 = {}): boolean | null => {
  let result = true
  const areValidEntries = isObject(object1) && isObject(object2)
  if (areValidEntries) {
    const keys1 = Object.keys(object1)
    const keys2 = Object.keys(object2)

    if (keys1.length !== keys2.length) {
      return false
    }

    keys1.forEach((key) => {
      const val1 = object1[key]
      const val2 = object2[key]

      const areObjects = isObject(val1) && isObject(val2)

      if ((areObjects && !isDeepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
        result = false
      }
    })
    return result
  }
  return null
}
